import { BlogHeadProps } from './blog-head'

const FACEBOOK_APP_ID = process.env.NEXT_PUBLIC_FACEBOOK_APP_ID || ''
const FACEBOOK_ADMINS = process.env.NEXT_PUBLIC_FACEBOOK_ADMINS || ''

export const getMetaTags = ({
  title,
  canonicalUrl,
  description,
  keywords,
  imageAlternativeText,
}: Omit<BlogHeadProps, 'blogLabel'>) => {
  return [
    { property: 'fb:app_id', content: FACEBOOK_APP_ID },
    { property: 'fb:admins', content: FACEBOOK_ADMINS },
    { property: 'og:url', content: canonicalUrl },
    { property: 'og:type', content: 'website' },
    { property: 'og:title', content: title },
    {
      property: 'og:image',
      content: 'https://static.jusbr.com/images/logo/logo-jusbrasil-1200-675.png',
    },
    { property: 'og:image:type', content: 'image/png' },
    { property: 'og:image:width', content: '1200' },
    { property: 'og:image:height', content: '675' },
    { property: 'og:image:alt', content: imageAlternativeText },
    { property: 'og:locale', content: 'pt_BR' },
    { property: 'og:description', content: description },
    { property: 'og:site_name', content: 'Jusbrasil' },
    { name: 'description', content: description },
    { name: 'keywords', content: keywords.join() },
  ]
}
